import React from "react";
import { cva } from "class-variance-authority";
import { Info, CheckCircle2, AlertTriangle, XCircle } from "lucide-react";
import { cn } from "../../lib/cn";

const alertStyles = cva("flex items-start gap-3 rounded border px-4 py-3 text-sm", {
  variants: {
    variant: {
      info: "bg-primary-50 text-primary-700 border-primary-100 dark:bg-primary-900/30 dark:text-primary-300 dark:border-primary-700/40",
      success: "bg-success-50 text-success-700 border-success-500/20 dark:bg-success-700/20 dark:text-success-50 dark:border-success-500/30",
      warning: "bg-warning-50 text-warning-700 border-warning-500/20 dark:bg-warning-700/20 dark:text-warning-50 dark:border-warning-500/30",
      danger: "bg-danger-50 text-danger-700 border-danger-500/20 dark:bg-danger-700/20 dark:text-danger-50 dark:border-danger-500/30",
    },
  },
  defaultVariants: {
    variant: "info",
  },
});

const icons = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  danger: XCircle,
};

/**
 * Alert - inline banner.
 * @param {"info"|"success"|"warning"|"danger"} [variant="info"]
 * @param {string} [title]
 * @param {string} [className]
 * @param {React.ReactNode} children
 */
export function Alert({ variant = "info", title, className, children, ...props }) {
  const Icon = icons[variant];

  return (
    <div role="alert" className={cn(alertStyles({ variant }), className)} {...props}>
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
      <div>
        {title && <p className="font-medium">{title}</p>}
        {children && <div className={cn(title && "mt-0.5")}>{children}</div>}
      </div>
    </div>
  );
}
